module.exports = __webpack_public_path__ + "static/pic01@5xwebp-3a2ae233007e72083eac67ee229bdbc5.webp";